import { createContext, useState } from "react";

const AuthContext = createContext();

const AuthProvider = ({children}) => {
    let storedKey = localStorage.getItem('some-key')
    storedKey = JSON.parse(storedKey)
    const timestamp = Date.now();
    const eightHours = 28800000;
    if(timestamp - storedKey?.timestamp > eightHours) {
        storedKey = {}
    }
    const [auth, setAuth] = useState(storedKey || {});

    return (
        <AuthContext.Provider value = {{auth, setAuth}}>
            {children}
        </AuthContext.Provider>
    )
}

export { AuthContext, AuthProvider};